import Tooltip from "./Tooltip";
import Button from "./Button";
import Modal from "./Modal";
import Divider from "./Divider";
import IconButton from "./IconButton";
import Input from "./Input";
import AdjustInput from "./AdjustInput";
import Card from "./Card";
import Fonts from "./Fonts";

const components = {
  Divider,
  Tooltip,
  Button,
  IconButton,
  Input,
  AdjustInput,
  Modal,
  Card,
  Fonts,
};

export default components;
